export function signInRequest(email, password) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: {email, password},
  };
}

export function signInRequestByMicrosoftIdToken(idToken) {
  return {
    type: '@auth/SIGN_IN_REQUEST_BY_MICROSOFT_ID_TOKEN',
    payload: { idToken },
  };
}

export function signInSuccess(token, user) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token, user },
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  };
}

export function signOut(msalInstance) {
  return {
    type: '@auth/SIGN_OUT',
    payload: { msalInstance },
  };
}

export function signOutSuccess() {
  return {
    type: '@auth/SIGN_OUT_SUCCESS',
  };
}
